const CREATE_CLIENT = 'CREATE_CLIENT';
const UPDATE_CLIENT = 'UPDATE_CLIENT';
const DELETE_CLIENT = 'DELETE_CLIENT';

export {
	CREATE_CLIENT,
	UPDATE_CLIENT,
	DELETE_CLIENT
}